import { BaseChartComponent, get, l10nNumber } from './charts-shared';

export default class PieBreakdownChartComponent extends BaseChartComponent {
  constructor(selector, data) {
    super(selector, data);
    this.mapData = (rawData) => {
      const seriesData = get(rawData, 'series');

      const parsedSeries = seriesData.map((s) => {
        s.data = s.data.map((d) => {
          const number = parseFloat(parseFloat(d).toFixed(1));

          return number || 0;
        });

        return s;
      });

      return { parsedSeries, rawData };
    };
  }

  makeChart() {
    const { parsedSeries, rawData } = this.data;
    const { dataType } = rawData;
    const isPercentage = dataType === 'percentage';
    const categoryName = rawData.categories.name;

    Highcharts.chart(this.element.attr('id'), {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      title: {
        text: null,
      },
      legend: {
        title: {
          text: categoryName,
          style: {
            fontSize: '16px',
          },
        },
        align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        labelFormatter() {
          return `${this.name} ${l10nNumber(this.y, isPercentage)}`;
        },
        itemMarginTop: 4,
        floating: true,
        itemStyle: {
          fontSize: '14px',
          fontWeight: 'normal',
        },
      },
      series: [
        {
          colorByPoint: true,
          data: rawData.categories.data.map((c, i) => {
            return {
              name: c,
              y: parsedSeries[0].data[i],
            };
          }),
        },
      ],
      tooltip: {
        pointFormatter() {
          return `<b>${l10nNumber(this.y, isPercentage)}</b>`;
        },
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 750,
            },
            chartOptions: {
              legend: {
                floating: false,
              },
            },
          },
          {
            condition: {
              maxWidth: 550,
            },
            chartOptions: {
              legend: {
                align: 'center',
                verticalAlign: 'bottom',
                floating: false,
              },
            },
          },
        ],
      },
    });
  }
}
